import React from 'react';
import { ANALYTICS_TIMEZONE, timeZoneLabel } from '../utils/timezone';
import './AnalyticsTimezoneNote.css';

/**
 * Small caption telling the reader which timezone a report's days are cut on.
 *
 * GA4 shards its export tables on the property's timezone, so every day bucket
 * in every report is that zone's day — not the reader's. Without saying so, a
 * chart labelled "8/21" silently means something different to someone on the
 * East Coast.
 *
 * Pass `timezone` from the report's API response so the label tracks the backend's
 * FIREBASE_ANALYTICS_TIMEZONE rather than a constant that can quietly drift.
 *
 * @param {object} props
 * @param {string} [props.timezone] - IANA zone from the report response
 * @param {string} [props.className] - extra class for placement
 */
const AnalyticsTimezoneNote = ({ timezone, className = '' }) => {
  const zone = timezone || ANALYTICS_TIMEZONE;

  return (
    <p className={`analytics-tz-caption ${className}`.trim()}>
      Dates and daily buckets are in {timeZoneLabel(zone)}
    </p>
  );
};

export default AnalyticsTimezoneNote;
